/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

let isProduction = false;

if (process.env.NODE_ENV == "production") {
    isProduction = true;
}

require("./bootstrap");

import { flare } from "@flareapp/flare-client";
import { flareVue } from "@flareapp/flare-vue";
import Vue from "vue";
Vue.use(flareVue);

if (isProduction) {
    flare.light("qyYa4YTC43WpHvAlLadKCdOWik8FfA3g");
}

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

import router from "./router";
import store from "./store";
import VueMeta from "vue-meta";

Vue.use(VueMeta);

import Hotjar from "vue-hotjar";
Vue.use(Hotjar, {
    id: "5064922", // Hotjar Site ID
    isProduction: isProduction,
});

import VueGtag from "vue-gtag";
Vue.use(VueGtag, {
    config: {
        id: "UA-173619762-1",
    },
});

import { mapState, mapActions } from "vuex";

Vue.mixin({
    computed: {
        ...mapState([
            "appProcessing",
            "apiError",
            "systemFontsLoaded",
            "userFontLoaded",
        ]),
        ...mapState("users", {
            user: (state) => state.user,
        }),
        ...mapState("cart", {
            cart: (state) => state.cart,
        }),
        ...mapState("notifications", {
            showNotification: (state) => state.showNotification,
            notificationMessage: (state) => state.notificationMessage,
            notificationType: (state) => state.notificationType,
        }),
        ...mapState("modals", {
            activeModal: (state) => state.activeModal,
        }),
        ...mapState("guests", {
            guest: (state) => state.guest,
        }),
        ...mapState("settings", {
            appPrice: (state) => state.price,
            stripeApplicationFee: (state) => state.stripeApplicationFee,
            primaryColor: (state) => state.primaryColor,
            colorPresets: (state) => state.colorPresets,
        }),
        ...mapState("menus", {
            rawMenu: (state) => state.rawMenu,
            selectedMenuItemId: (state) => state.selectedMenuItemId,
            categoryIdPrefix: (state) => state.categoryIdPrefix,
            itemIdPrefix: (state) => state.itemIdPrefix,
        }),
    },
    methods: {
        ...mapActions([
            "setAppProcessing",
            "setAppUpdated",
            "setSystemFontsLoaded",
            "setUserFontLoaded",
        ]),
        ...mapActions("notifications", ["displayNotification"]),
        ...mapActions("modals", [
            "openModal",
            "clickModalOverlay",
            "closeModals",
        ]),
        ...mapActions("guests", ["getGuest"]),
        ...mapActions("users", ["getUser"]),
        ...mapActions("cart", ["getCart", "refreshCart"]),
        ...mapActions("menus", [
            "getMenu",
            "refreshMenu",
            "setSelectedMenuItemId",
        ]),
        isMobileDevice() {
            if (
                /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                    navigator.userAgent
                )
            ) {
                // true for mobile device
                return true;
            }
            return false;
        },
        enableBodyScroll() {
            document
                .getElementById("app")
                .classList.remove("overflow-hidden", "vh-100");
        },
        disableBodyScroll() {
            document
                .getElementById("app")
                .classList.add("overflow-hidden", "vh-100");
        },
    },
});

import apiErrorMixin from "./mixins/apiErrorMixin";
Vue.mixin(apiErrorMixin);

import App from "./App.vue";

const app = new Vue({
    render: (h) => h(App),
    store,
    router,
}).$mount("#application");
